import React from "react";
import "../../Assets/Styles/Dashboard/DashboardSideBar.css";
import auth from "../../FirebaseInit/FirebaseInit";
import { useSignOut } from "react-firebase-hooks/auth";
import Loading from "../Shear/Loading/Loading";
import AdminMenuItems from "./AdminDashboard/AdminMenuItems";
import UserMenuItems from "./UserDashboard/UserMenuItems";

const DashboardSideBar = ({profile}) => {
  const [signOut, loading] = useSignOut(auth);

  if (loading) {
    return <Loading />;
  }
  return (
    <section className="sidebar ">
      {profile?.role ? <AdminMenuItems /> : <UserMenuItems />}
      <div className=" absolute bottom-0 w-full left-0 p-5 hidden max-xl:block">
        <button
          onClick={() => {
            localStorage.removeItem("accessToken");
            signOut();
          }}
          className="custom_button w-full inline-block"
        >
          Sign Out{" "}
        </button>
      </div>
    </section>
  );
};

export default DashboardSideBar;
